import { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import toast from 'react-hot-toast';
import { SPEC_IMPORT_PROMPT } from '../../constants/specImportPrompt';

export default function SpecImportGuideTab() {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(SPEC_IMPORT_PROMPT.content);
      setCopied(true);
      toast.success('프롬프트가 클립보드에 복사되었습니다.');
      setTimeout(() => setCopied(false), 3000);
    } catch {
      toast.error('복사에 실패했습니다. 직접 선택하여 복사해주세요.');
    }
  };

  return (
    <div className="space-y-6">
      {/* 안내 */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h4 className="font-medium text-blue-800 mb-2">
          Confluence, Notion, PPT 등에서 작성한 기능명세를 MaioS 형식으로 변환하는 방법
        </h4>
        <ol className="text-sm text-blue-700 space-y-1.5 list-decimal list-inside">
          <li>외부 도구에서 기능명세를 마크다운(.md) 파일로 내보내기 합니다.</li>
          <li>아래 프롬프트를 복사합니다.</li>
          <li>Cowork(또는 Claude)에 프롬프트를 붙여넣고, 마크다운 파일을 첨부합니다.</li>
          <li>생성된 JSON을 <strong>&quot;JSON/XLSX 업로드&quot;</strong> 탭에 붙여넣기 합니다.</li>
        </ol>
      </div>

      {/* 프롬프트 영역 */}
      <div>
        <div className="flex items-center justify-between mb-2">
          <h4 className="text-sm font-medium text-gray-700">변환 프롬프트</h4>
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-400">v{SPEC_IMPORT_PROMPT.version}</span>
            <button
              onClick={handleCopy}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              {copied ? (
                <>
                  <Check className="size-3.5" /> 복사됨
                </>
              ) : (
                <>
                  <Copy className="size-3.5" /> 프롬프트 복사
                </>
              )}
            </button>
          </div>
        </div>
        <div className="border rounded-lg bg-gray-50 max-h-96 overflow-y-auto">
          <pre className="p-4 text-sm text-gray-700 whitespace-pre-wrap font-mono">
            {SPEC_IMPORT_PROMPT.content}
          </pre>
        </div>
      </div>

      {/* 팁 */}
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
        <p className="text-sm text-amber-800">
          <strong>Tip:</strong> 변환 결과가 정확하지 않으면, 프롬프트에 원본 문서의 구조 설명을
          추가하면 변환 품질이 향상됩니다. 예) &quot;이 문서는 ## 헤딩으로 각 기능이 구분되어 있고,
          테이블로 상세 명세가 작성되어 있습니다.&quot;
        </p>
      </div>
    </div>
  );
}
